import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import Banner from "../Common/Banner";
import { useNavigate } from "react-router-dom";
import api from "../Auth/Middleware";

const intialTeacherData = {
  firstName: "",
  lastName: "",
  dOB: "",
  contact: "",
  address: "",
  hireDate: "",
};
const AddTeacher = () => {
  const [teacherData, setTeacherData] = useState(intialTeacherData);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogContent, setDialogContent] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setTeacherData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const validateMobileNumber = (mobileNumber) => {
    if (mobileNumber === "") {
      return true;
    }
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobileNumber);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await api.post("Student/AddTeacher", teacherData);
      if (response.status === 200) {
        setIsSuccess(true);
        setDialogTitle("Teacher Added Successfully");
        setDialogContent([response.data]);
        setDialogOpen(true);
      } else {
        setIsSuccess(false);
        setDialogTitle("Error occured");
        setDialogContent(JSON.stringify(response.data));
        setDialogOpen(true);
      }
    } catch (error) {
      setIsSuccess(false);
      setDialogTitle("API Error");
      setDialogContent("An error occurred while processing the request.");
      setDialogOpen(true);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    navigate("/adminDashboard");
  };
  const handleAddMoreDialog = () => {
    setTeacherData(intialTeacherData);
    setDialogOpen(false);
  };
  const handleTryAgainDialog = () => {
    setDialogOpen(false);
  };

  const handleReset = () => {
    setTeacherData(intialTeacherData);
  };
  const headers = Object.keys(dialogContent[0] || {});

  return (
    <>
      <Banner title="Add Teacher" currentpage="Add Teacher" previousPage = "Admin Dashboard" link="/adminDashboard"/>
      <div className="container-fluid my-5 d-flex align-items-center justify-content-center">
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <div className="card shadow-sm p-4">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="First Name"
                        name="firstName"
                        required
                        fullWidth
                        value={teacherData.firstName}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Last Name"
                        name="lastName"
                        required
                        fullWidth
                        value={teacherData.lastName}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Date of Birth"
                        name="dOB"
                        required
                        type="date"
                        fullWidth
                        value={teacherData.dOB}
                        onChange={handleInputChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Hire Date"
                        name="hireDate"
                        required
                        type="date"
                        fullWidth
                        value={teacherData.hireDate}
                        onChange={handleInputChange}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Contact"
                        name="contact"
                        required
                        fullWidth
                        value={teacherData.contact}
                        onChange={handleInputChange}
                        inputProps={{
                          minLength: 10,
                          maxLength: 10,
                          pattern: "^[6-9]\\d{9}$",
                        }}
                        error={!validateMobileNumber(teacherData.contact)}
                        helperText="Please enter a valid 10-digit mobile number"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Address"
                        name="address"
                        required
                        fullWidth
                        value={teacherData.address}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button type="submit" variant="contained" color="primary">
                        Add Teacher
                      </Button>
                      <Button
                        sx={{ margin: "0 2rem" }}
                        type="reset"
                        onClick={handleReset}
                        variant="contained"
                        color="secondary"
                      >
                        Reset
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dialogContent.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {headers.map((header, colIndex) => (
                    <TableCell key={colIndex}>{row[header]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </DialogContent>
        <DialogActions>
          {isSuccess ? (
            <Button onClick={handleAddMoreDialog} color="primary">
              Add More
            </Button>
          ) : (
            <Button onClick={handleTryAgainDialog} color="primary">
              Try Again
            </Button>
          )}
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddTeacher;
